// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedPosterior_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0V24H24V0H0ZM22 2H2V22H22V2Z" class="svg-bg"/>
  <path d="M12.148 6C13.62 6 14.692 6.32 15.364 6.96C16.0467 7.58933 16.388 8.45867 16.388 9.568C16.388 10.24 16.2493 10.864 15.972 11.44C15.6947 12.016 15.2307 12.48 14.58 12.832C13.94 13.184 13.0653 13.36 11.956 13.36H10.916V17.424H8.5V6H12.148ZM12.02 7.984H10.916V11.376H11.716C12.3987 11.376 12.9373 11.2427 13.332 10.976C13.7373 10.6987 13.94 10.256 13.94 9.648C13.94 8.53867 13.3 7.984 12.02 7.984Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedPosterior is a generated icon component.
 */
let IconMedPosterior = IconMedPosterior_1 = class IconMedPosterior extends IconBaseElement {
    render() {
        return html `${IconMedPosterior_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedPosterior.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedPosterior = IconMedPosterior_1 = __decorate([
    customElement('zui-icon-med-posterior')
], IconMedPosterior);
export { IconMedPosterior };
